__turbopack_context__.v({
  "className": "XaDlrW_className",
  "variable": "XaDlrW_variable",
});
